exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Sidebar-local__sidebar--3jBlb {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n\n.Sidebar-local__withMask--105-5 {\n  background: rgba(41, 57, 77, 0.6); }\n\n.Sidebar-local__content--1rkux {\n  -webkit-box-shadow: 0 0 1.2rem 0 rgba(44, 43, 63, 0.3);\n          box-shadow: 0 0 1.2rem 0 rgba(44, 43, 63, 0.3);\n  background-color: #29394d;\n  width: 535px;\n  height: 100%;\n  -webkit-transition: right 0.5s ease-in-out;\n  -o-transition: right 0.5s ease-in-out;\n  transition: right 0.5s ease-in-out;\n  position: relative;\n  right: -21%; }\n", ""]);

// exports
exports.locals = {
	"sidebar": "Sidebar-local__sidebar--3jBlb",
	"withMask": "Sidebar-local__withMask--105-5",
	"content": "Sidebar-local__content--1rkux"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Sidebar/Sidebar.local.scss
// module id = 491
// module chunks = 0